import React, { createContext,useState } from 'react'


export const context=createContext()


export const ContextProvider = ({children}) => {
    const [textcolour,settextcolour]=useState('#0ea5ea')
  const [colorChoose,setuserColorChoose] =useState(false)
     
    return (
   
<context.Provider value={{textcolour,settextcolour,setuserColorChoose,colorChoose}} >
    {children}
</context.Provider>

  )
}

export default ContextProvider